import { routeDirectory } from 'modules';
import { RouteObject } from 'react-router-dom';
import { TransactionListActivity } from './TransactionListActivity/TransactionListActivity';
import { StoreDetailActivity } from './StoreDetailActivity/StoreDetailActivity';
import { StoreListActivity } from './StoreListActivity/StoreListActivity';
import { StoreSettingsActivity } from './StoreSettingsActivity/StoreSettingsActivity';
import { InventoryActivity } from 'activities/admin/InventoryActivity/InventoryActivity';



export const routes: RouteObject[] = [
  {
    path: routeDirectory.partner.stores.raw,
    element: <StoreListActivity />
  },
  {
    path: routeDirectory.partner.storeDetail.raw,
    element: <StoreDetailActivity />
  },
  {
    path: routeDirectory.partner.orderList.raw,
    element: <TransactionListActivity />
  },
  {
    path: routeDirectory.partner.storeSettings.raw,
    element: <StoreSettingsActivity />
  },
  {
    path: routeDirectory.partner.inventory.raw,
    element: <InventoryActivity />
  }
];
